import { pipe } from 'fp-ts/lib/function';
import { includes, isString, split } from 'fp-ts/string';
import { fromPredicate, getOrElse, match } from 'fp-ts/Option';
import { head } from 'fp-ts/lib/Array';
import { toArray } from 'fp-ts/lib/ReadonlyArray';

const _phoneCodeDivider = '---';

export const encodePhoneCode = (phoneCode: string, index: number) => {
  return `${phoneCode}${_phoneCodeDivider}${index}`;
};

export const displayOnlyPhoneNumber = (phoneCode: string) => {
  let match = phoneCode.match(/^\+(\d+)/);
  let result = '';
  if (match) {
    result = match[0].replace('+', '');
  }
  return result;
};

export const decodePhoneCode = (phoneCode: string): string => {
  return pipe(
    phoneCode,
    fromPredicate(isString),
    match(
      () => '',
      () =>
        pipe(
          phoneCode,
          fromPredicate(includes(_phoneCodeDivider)),
          match(
            () => phoneCode,
            (pCode) =>
              pipe(
                pCode,
                split(_phoneCodeDivider),
                toArray,
                head,
                getOrElse(() => '')
              )
          )
        )
    )
  );
};
